import React, { useEffect, useState, useRef } from "react";
import "./CompanyProfile.css";
import UploadImage from "../assets/images/icon.svg";
import { url } from "../store/sagas/API";
import { Card, Container, Table } from "react-bootstrap";

const CompanyProfileComponent = ({
  dragActive,
  image,
  onButtonClick,
  handleDrop,
  handleChange,
  handleDrag,
  inputRef,
  activeEmployees,
  availableLicences,
  totalLicences,
}) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          textAlign: "left",
          paddingTop: "10px",
        }}
      >
        <div
          style={{
            marginTop: "10px",
            fontSize: "var(--main-heading)",
            fontWeight: "var(--heading-font-weight)",
          }}
        >
          Company Profile
        </div>
        <br />
        <label style={{ textAlign: "left" }}>
          Please upload your company logo:
        </label>
        <div style={{ display: "flex", alignItems: "center" }}>
          <form
            onDragEnter={handleDrag}
            onSubmit={(e) => e.preventDefault()}
            style={{
              padding: "10px",
              cursor: "pointer",
            }}
          >
            <input
              ref={inputRef}
              type="file"
              id="input-file-upload"
              accept="image/svg+xml, image/png"
              onChange={handleChange}
            />
            <label id="label-file-upload" htmlFor="input-file-upload">
              <button
                className="upload-button"
                onClick={(e) => {
                  e.preventDefault();
                  onButtonClick();
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "none",
                  border: "none",
                  color: "#0DA14B",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                <div style={{ marginRight: "10px" }}>
                  <img src={UploadImage} />
                </div>
                Upload an image
              </button>
              <div style={{ fontSize: "14px", color: "#555" }}>
                or drag and drop an image file here
              </div>
            </label>
            {dragActive && (
              <div
                id="drag-file-element"
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                }}
              ></div>
            )}
          </form>
          {image && (
            <div>
              <img
                src={url + image}
                alt="Uploaded"
                style={{ width: "100px" }}
              />
            </div>
          )}
        </div>
      </div>
      <div className="my-5" style={{ maxWidth: "800px" }}>
        <h4 className="mb-4 text-start fw-bold">Licence Details</h4>

        <Card>
          <Card.Body>
            <Table bordered hover responsive className="align-middle">
              <thead className="table-light">
                <tr>
                  <th className="text-start">Product Name</th>
                  <th className="text-start">Assigned Licences</th>
                  <th className="text-start">Available Licences</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-start">
                    <strong>Excelrate GEMS</strong>
                  </td>
                  <td className="text-start">{`${activeEmployees} / ${totalLicences}`}</td>
                  <td className="text-start">{`${availableLicences} / ${totalLicences}`}</td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default CompanyProfileComponent;
